import React from 'react';
import { Views, Neo } from '@singularsystems/neo-react';
import AuthorisationVM from './AuthorisationVM';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import InvitedUsersComponent from './Components/InvitedUsersComponent';
import LockedOutUsersComponent from './Components/LockedOutUsersComponent';
import CollapsibleCard from '../../../App/Components/CollapsibleCard';

@observer
export default class AuthorisationView extends Views.ViewBase<AuthorisationVM> {

    constructor(props: unknown) {
        super("User Management", AuthorisationVM, props);
    }

    public render() {
        this.viewModel.tabManager.selectedTab = TextConstants.Titles.LockedOutUsers;

        return (
            <div className="AuthorisationView">
                <CollapsibleCard title={TextConstants.Titles.Authorisation} isExpanded={true}>
                    <Neo.TabContainer tabManager={this.viewModel.tabManager}>
                        <InvitedUsersComponent viewModel={this.viewModel}></InvitedUsersComponent>
                        <LockedOutUsersComponent viewModel={this.viewModel}></LockedOutUsersComponent>
                    </Neo.TabContainer>
                </CollapsibleCard>
            </div>
        );
    }
}